module.exports = __webpack_public_path__ + "media/images/ceremony/plans/2/hall-list/plan-ceremony-lineup-kanto-4-758e9166d4aad875a16e0633e1a047de.png";